import templateStr from 'text!./psa-policy-quote-summary.html';
import miniPolicyChangeStr from 'text!customerEdge/gateway/directives/PSAMiniPolicyChangeDirective/psa-policy-change-popup.html';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

// <psa-policy-quote-summary> should be moved to OOTB <gw-policy-coverages>
// it duplicates behavior.
// <gw-policy-coverages> is built to present data from a multi-policy-line Policies
export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            vehicles: '<',
            coverages: '<',
            latestPeriod: '<',
            accountHolder: '<',
            totalPremium: '<',
            totalCost: '<',
            totalTax: '<',
        },
        controller: ['$scope', 'ViewModelService', 'ModalService', 'MiniEndorsementService_PSA', '$state','$filter',
            ($scope, ViewModelService, ModalService, MiniEndorsementService_PSA, $state,$filter) => {
                const ctrl = Object.create(BaseCtrl);
                $scope.accountHolderVM = ViewModelService.create($scope.accountHolder, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO');
                $scope.miniPolicyChangeAllowed = $scope.latestPeriod.canChange && $scope.latestPeriod.canceled !== true;
                //UCWAR-2011
                //INCI11878967 | MARKETING FEE SHOULD NOT APPEAR ON THE PORTAL 
                if($scope.accountHolderVM.producerCodeLabel.value == 'spoticar'){
                    $scope.marketingFee = {amount: 0, currency: "eur"};
                } else {
                    $scope.marketingFee = {amount: 0, currency: "eur"};
                }

                //UCWAR-1637
                function contains(str, text){
                    return str.indexOf(text) >= 0;
                }
                $scope.isEGVO = false;
                if(contains($scope.latestPeriod.virtualProduct_PSA, 'EGVO')){
                    $scope.isEGVO = true
                }
                //UCWPRODENG-764 
                $scope.policy = $scope.$parent.policy
                if($scope.policy !== undefined){
                    //$scope.policyManagementType_PSA = $scope.policy.policyManagementType_PSA;
                     var GWUserLanguage = localStorage.getItem('localLanguage');
                    if(GWUserLanguage == 'de'){
                        $scope.policyManagementType_PSA = $filter('translate')('typekey.ManagementType_PSA.'+$scope.policy.policyManagementType_PSA);
                    }
                    else{
                        $scope.policyManagementType_PSA = $scope.policy.policyManagementType_PSA;
                    }
                    //UCWPRODENG-761
                    $scope.sellerSite  = $scope.vehicles[0].sellerSite;
                }
                //   below function ctrl.isEgvo has been added against US UCWPRODENG-720
                $scope.isEgvo = () => {
                    let checkEgvo = true;
                    if ($scope.latestPeriod) {
                        var productEgvo = $scope.latestPeriod.policyLines;
                        for (var i = 0; i < productEgvo.length; i++) {
                            if (productEgvo[i].firstCoverableVirtualFlavour_PSA && productEgvo[i].firstCoverableVirtualFlavour_PSA.includes("EGVO")) {
                                checkEgvo = false;
                            }
                        }
                    }
                    return checkEgvo;
                };
                $scope.beginMiniPolicyChange = (vehicle) => {
                    ModalService.showSimpleDialog(miniPolicyChangeStr, {
                        vehicle: vehicle,
                        onProceed: (newVehicle) => {
                            const promise = MiniEndorsementService_PSA.changeLicensePlateAndVIN($scope.latestPeriod.policyNumber, vehicle.fixedId, newVehicle.license, newVehicle.vin);
                            promise.then(() => {
                                $state.reload();
                            }).catch((err) => {
                                if (err.baseError.error.message.endsWith("Vin is already associated with another Policy")) {
                                    ModalService.showError('gateway.views.modal.Error', 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VIN is not unique');
                                } else {
                                    ModalService.showError('gateway.views.modal.Error', 'quoteandbind.views.contact-us.Please contact us with the reference number below and we would be pleased to assist you.');
                                }
                            });
                        }
                    });
                };
            }]
    };
}];
